import wishlistApi from '@/api/wishlist';

const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_WISHLIST_ADDED = 'SET_WISHLIST_ADDED';

const state = {
	isFetching: false,
	isFetched: false,
	wishlistAdded: [],
};

const getters = {
	wishlistAdded: state => state.wishlistAdded,
	isFetching: state => state.isFetching,
};

const mutations = {
	[SET_WISHLIST_ADDED](state, products) {
		state.wishlistAdded = products;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
};

const actions = {
	getProductWishlistAdded({ commit, getters }) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const products = response.data || [];
				if (products.length !== 0) {
					commit(SET_WISHLIST_ADDED, products);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			wishlistApi.getWishlist(callback, errorCallback);
		}
	},
	appendWishlistAdded({ commit }, newProduct) {
		const products = [
			...state.wishlistAdded,
			newProduct,
		];
		commit(SET_WISHLIST_ADDED, products);
	},
	removeWishlistAdded({ commit }, selectedProduct) {
		const products = [
			...state.wishlistAdded,
		];
		const filteredProducts = products.filter(product => product._id !== selectedProduct._id);
		commit(SET_WISHLIST_ADDED, filteredProducts);
	},
	bulkRemoveWishlistAdded({ commit }, selectedProducts) {
		const products = [
			...state.wishlistAdded,
		];
		const filteredProducts = products.filter(product => !selectedProducts.includes(product._id));
		commit(SET_WISHLIST_ADDED, filteredProducts);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
